var _rect, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgMajorityVote = function SvgMajorityVote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.73 21.248a3.992 3.992 0 10-4.77 0 5.768 5.768 0 00-4.713 5.67H20.44a5.768 5.768 0 00-4.712-5.67zM31.276 21.248a3.992 3.992 0 10-4.77 0 5.768 5.768 0 00-4.713 5.67h14.195a5.768 5.768 0 00-4.712-5.67z",
    fill: "#33BB40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.757 38.149a3.992 3.992 0 10-4.77 0 5.768 5.768 0 00-4.713 5.67h14.195a5.768 5.768 0 00-4.712-5.67zM38.303 38.149a3.992 3.992 0 10-4.77 0 5.768 5.768 0 00-4.713 5.67h14.195a5.768 5.768 0 00-4.712-5.67z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.822 21.248a3.992 3.992 0 10-4.77 0 5.768 5.768 0 00-4.712 5.67h14.194a5.768 5.768 0 00-4.712-5.67z",
    fill: "#33BB40"
  })));
};

export default SvgMajorityVote;